module.exports = __webpack_public_path__ + "static/media/default.6732bd42.png";